var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54883 11.084H8.38086C9.08984 11.084 9.49414 10.6562 9.49414 9.97656V7.19922H12.0312C12.4297 7.19922 12.7344 6.95898 12.7344 6.58398C12.7344 6.34961 12.623 6.17969 12.4355 5.99219L7.14453 0.707031C6.89258 0.455078 6.69336 0.355469 6.46484 0.355469C6.23633 0.355469 6.03125 0.455078 5.78516 0.707031L0.494141 5.99219C0.300781 6.18555 0.195312 6.34961 0.195312 6.58398C0.195312 6.95898 0.5 7.19922 0.898438 7.19922H3.43555V9.97656C3.43555 10.6562 3.83984 11.084 4.54883 11.084Z",
    fill: "#FCFCFC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow-up.1b6775ed5a34b87a497c0a88fbe14795.svg";